<div class="popup" *ngIf="visible">
  <div class="popup-content">
    <h3>Agent Offline</h3>
    <p>Our agents are currently unavailable. Please try again later or contact support.</p>
    <button (click)="closePopup()">Close</button>
  </div>
</div>
